import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "myelite_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Guest session id for freemium chat
const GUEST_KEY = "myelite_guest_session";
export function getGuestSession() {
  let s = localStorage.getItem(GUEST_KEY);
  if (!s || !/^guest-[A-Za-z0-9_-]{32,64}$/.test(s)) {
    // 192-bit crypto-random bearer id (the guest transcript is bound to it)
    const bytes = crypto.getRandomValues(new Uint8Array(24));
    s = "guest-" + Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
    localStorage.setItem(GUEST_KEY, s);
  }
  return s;
}
export const clearGuestSession = () => localStorage.removeItem(GUEST_KEY);

// Download a generated CV document as a Word (.docx) file.
export async function downloadCvDocx(docId, title = "cv", format = "docx") {
  const res = await fetch(`${API}/tools/documents/${docId}/${format === "pdf" ? "pdf" : "docx"}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!res.ok) throw new Error("Download failed");
  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(title || "cv").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "cv"}.${format === "pdf" ? "pdf" : "docx"}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

